import React from 'react';
import styled from 'styled-components';

import { AboutCardPrimary } from '@/components/LandingWidgets';
import { useTokensLandingData } from '@/modules/TokensLanding/hooks';
import { ContentContainer } from '@/modules/TokensLanding/common.styles';

function Description() {
  const { descriptionTitle, description } = useTokensLandingData();

  if (!descriptionTitle || !description) {
    return null;
  }

  return (
    <Component>
      <ContentContainer>
        <AboutCardPrimary title={descriptionTitle} topText={description} />
      </ContentContainer>
    </Component>
  );
}

export default Description;

const Component = styled.section`
  padding: 15px 0;
`;
